import React, { useMemo, useState } from 'react';
import { isArray } from 'lodash';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
// antd
import { Menu, Typography, Row } from 'antd';
import { ShoppingOutlined, DoubleRightOutlined } from '@ant-design/icons';
// components
import { RibbonButton } from 'common/components';
// hooks
import { APL_KEY, useGetAPLGrid } from 'hooks/apl/useGetAPLGrid';
import { useFilterGrid } from 'hooks/useFilterGrid';
// redux
import * as actionsGridView from 'common/components/grid-view/controllers/actions';
// sections
import FilterMyAplsModal from './FilterMyAplsModal';
// less
import './FilterMyAPLs.less';

export default function FilterMyAPLs(props) {
  const { entityType = 'product' } = props;

  const dispatch = useDispatch();

  const [visible, setVisible] = useState(false);
  const { gridFilters, updateGridFilter } = useFilterGrid({
    entityType,
  });
  const { data } = useGetAPLGrid({
    key: APL_KEY.getAplGrid(),
    params: {
      pageSize: 10,
      pageIndex: 1,
      sort: [{ fieldName: 'id', isAscending: false }],
    },
  });

  const hasMasterApl = useMemo(() => {
    if (isArray(data?.gridData)) {
      return data?.gridData.find(
        (val) => val?.aplName?.toLowerCase() === 'master apl'
      );
    }
    return false;
  }, [data]);

  const filterProductApl = useMemo(() => {
    if (isArray(gridFilters)) {
      return gridFilters.find((val) => val?.filter === 'apl');
    }
    return false;
  }, [gridFilters]);

  const handleFilterProducts = (filter) => {
    dispatch(actionsGridView.resetPageCurrent());

    const findFilterAPL = gridFilters.find((val) => val?.filter === 'apl');

    if (findFilterAPL?.value?.id === filter?.value?.id) {
      updateGridFilter(gridFilters.filter((val) => val?.filter !== 'apl'));
    } else {
      let newFilterProducts = [...gridFilters];
      newFilterProducts = newFilterProducts.filter(
        (val) => val?.filter !== 'apl'
      );

      newFilterProducts.push(filter);
      updateGridFilter(newFilterProducts);
    }
  };

  return (
    <Menu.SubMenu
      key='filter-apl'
      style={{ backgroundColor: 'inherit' }}
      title={
        <RibbonButton
          size='small'
          icon={<ShoppingOutlined />}
          label={'My APLs'}
          toggle={Boolean(filterProductApl)}
        />
      }
    >
      {!hasMasterApl && (
        <Menu.Item
          key='masterApl'
          disabled
          className={classNames({
            'filter-apl': true,
            'filter-apl--disabled': true,
          })}
        >
          <Typography.Text>Master APL</Typography.Text>
        </Menu.Item>
      )}
      {isArray(data?.gridData) &&
        data?.gridData.map((val) => (
          <Menu.Item
            key={val?.id}
            className={classNames({
              'filter-apl': true,
              'filter-apl--toggle':
                isArray(gridFilters) &&
                gridFilters.find((val) => val?.filter === 'apl')?.value?.id ===
                  val?.id,
            })}
            onClick={() =>
              handleFilterProducts({
                filter: 'apl',
                value: val,
              })
            }
          >
            <Typography.Text>{val?.aplName}</Typography.Text>
          </Menu.Item>
        ))}

      {data?.paging?.totalRecord > 10 && (
        <Menu.Item
          key='moreApl'
          onClick={() => setVisible(true)}
          className='filter-apl'
        >
          <Row className='filter-apl--more'>
            <DoubleRightOutlined style={{ transform: 'rotate(90deg)' }} />
          </Row>
        </Menu.Item>
      )}
      {visible && (
        <FilterMyAplsModal
          visible={visible}
          setVisible={setVisible}
          entityType={entityType}
        />
      )}
    </Menu.SubMenu>
  );
}
